<template>
  <div class="logos">
    <a href="https://www.nih.gov/" target="_blank">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/NIH.svg"
        alt="NIH"
        title="NIH"
        class="nih" />
      <img v-else src="./img/NIH-darkMode.svg" alt="NIH" title="NIH" class="nih" />
    </a>
    <a href="https://www.broadinstitute.org/" target="_blank">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/Broad.png"
        alt="Broad Institute"
        title="Broad Institute" />
      <img v-else src="./img/Broad-darkMode.png" alt="Broad Institute" title="Broad Institute" />
    </a>
  </div>
</template>

<script setup>
import {inject} from "vue";
const displayMode = inject("displayMode");
</script>

<style scoped>
.logos {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
}
img {
  height: clamp(20px, 8vw, 55px);
  width: auto;
  vertical-align: text-top;
}
img.nih {
  height: clamp(20px, 8vw, calc(55px * 1.4));
}
</style>
